import React from "react";

// import { Container } from './styles';
import "../../Assets/css/pages/login/login-2.css";

import backgroundIMG from "../../Assets/img/bg.jpg";
import LogoCapys from "../../Assets/img/LogoCapys.png";

import { ForgotForm } from "./ForgotForm/";
import { LoginForm } from "./LoginForm/";
import { RecoveryForm } from "./RecoveryForm";
import { useLocation } from "react-router-dom";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Login() {
    let location = useLocation();
    const recoveryPage = location.pathname.includes("/recuperarSenha");
    localStorage.removeItem("@token");

    return (
        <div className="header-fixed header-mobile-fixed header-bottom-enabled subheader-enabled page-loading">
            <div className="d-flex flex-column flex-root">
                <div
                    className="login login-2 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                    id="kt_login"
                    style={{ minHeight: "100vh", height: "100%" }}
                >
                    <div className="login-aside order-2 order-lg-1 d-flex flex-column-fluid flex-lg-row-auto bgi-size-cover bgi-no-repeat p-7 p-lg-10">
                        <div className="d-flex flex-row-fluid flex-column justify-content-between">
                            <div className="d-flex flex-column-fluid flex-column flex-center mt-5 mt-lg-0">
                                <a href="#/" className="mb-15 text-center">
                                    <img
                                        src={LogoCapys}
                                        className="max-h-75px"
                                        alt=""
                                    />
                                </a>
                                {recoveryPage ? (
                                    <RecoveryForm />
                                ) : (
                                    <>
                                        <LoginForm />
                                        <ForgotForm />
                                    </>
                                )}
                            </div>
                            <div className="d-flex flex-column-auto justify-content-between mt-1">
                                <div className="d-flex order-1 order-sm-2 my-2">
                                    <div className="nav nav-dark order-1 order-md-2 mr-4">
                                        <a
                                            href="https://capys.com.br/index.php/sobre-a-capys/politica-de-privacidade"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="nav-link pl-3 pr-0"
                                        >
                                            <FontAwesomeIcon
                                                icon={faHeadset}
                                                className="mr-2"
                                            />{" "}
                                            Política de Privacidade
                                        </a>
                                    </div>
                                    <div className="nav nav-dark order-1 order-md-2 mr-4">
                                        <a
                                            href="https://atendimento.capys.com.br/login.html"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="nav-link pl-3 pr-0"
                                        >
                                            <FontAwesomeIcon
                                                icon={faHeadset}
                                                className="mr-2"
                                            />{" "}
                                            Portal de Atendimentos CAPYS
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="order-1 order-lg-2 flex-column-auto flex-lg-row-fluid d-flex flex-column p-7"
                        style={{
                            backgroundImage: `url(${backgroundIMG})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            boxShadow: `rgb(0 0 0 / 76%) 0px 0px 0px 1000px inset`,
                        }}
                    >
                        <div className="d-flex flex-column-fluid flex-lg-center">
                            <div className="d-flex flex-column justify-content-center ">
                                <h3 className="display-3 font-weight-bold text-white">
                                    Bem-vindo ao CAPYS CRM!
                                </h3>
                                <label className="display-4 font-weight-bold text-CapysIT text-center">
                                    O CRM mais Completo do Mercado Imobiliário!
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
